import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _ from 'underscore';
import { createHashHistory } from 'history';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ButtonDropdown, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Row } from 'reactstrap';
import { v4 as uuidV4 } from 'uuid';
import AssetsFilterPanel from './assetsFilterPanel';
import AssetsPagingTable from './assetsPagingTable';
import AssetsRow from './assetsRow';
import { getIsPermittedWithAnyOfThesePermissions } from '../common/classes/permissions';
import entityComposition from '../common/classes/entityComposition';
import routeHelper from '../common/classes/routeHelper';
import ListPanel from '../common/containers/listPanel';
import Icon from '../common/containers/icon';
const hashHistory = createHashHistory();
const handleAssetSelect = id => {
  hashHistory.replace("/assets/".concat(id));
};
class Assets extends Component {
  constructor(props) {
    const initialIndexQuery = props.asset.initialIndexQuery,
      serverIndex = props.assetActions.serverIndex;
    super(props);
    this.state = {
      isBulkActionsOpen: false
    };
    this.filterChange = this.filterChange.bind(this);
    this.filterClear = () => serverIndex(initialIndexQuery);
    this.filterSearch = text => this.filterChange('text', text);
    this.filterSearchClear = () => this.filterChange('text', '');
    this.handleAction = this.handleAction.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
  }
  componentDidMount() {
    const _this$props = this.props,
      indexQuery = _this$props.asset.indexQuery,
      serverIndex = _this$props.assetActions.serverIndex,
      assetStatusIndexQuery = _this$props.assetStatus.indexQuery,
      assetStatusActionsServerIndex = _this$props.assetStatusActions.serverIndex,
      canView = _this$props.canView,
      location = _this$props.location;

    // Redirect and post authorization error message if permissions insufficient
    routeHelper.handleViewRedirect(canView, location);
    serverIndex(indexQuery);
    assetStatusActionsServerIndex(assetStatusIndexQuery);
  }
  filterChange(prop, value) {
    const _this$props2 = this.props,
      indexQuery = _this$props2.asset.indexQuery,
      serverFilter = _this$props2.assetActions.serverFilter;
    const newFilters = _objectSpread(_objectSpread({}, indexQuery.filters), {}, {
      [prop]: value
    });
    serverFilter(newFilters, indexQuery);
  }
  handleAction(key) {
    const _this$props3 = this.props,
      selected = _this$props3.asset.selected,
      duplicate = _this$props3.assetActions.duplicate;
    switch (key) {
      case 'duplicate':
        duplicate(selected);
        break;
      default:
      // do nothing;
    }
  }
  handleAdd() {
    const _this$props4 = this.props,
      create = _this$props4.assetActions.create,
      list = _this$props4.assetStatus.list,
      userID = _this$props4.login.user.user_id;
    const newID = uuidV4().toUpperCase();
    const availableStatus = list.filter(s => s.identifier === 'available');
    const assetStatusID = availableStatus[0].id;
    const defaultData = {
      id: newID,
      appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
      appCreatorID: userID,
      photos: [],
      details: [],
      assetStatusID
    };
    create(newID, defaultData);
    handleAssetSelect(newID);
  }
  handleSelect(id, event) {
    const assetActions = this.props.assetActions;
    if (event.target.checked) {
      assetActions.select(id);
    } else {
      assetActions.selectClear(id);
    }
  }
  handleSelectAll(event) {
    const _this$props5 = this.props,
      assetActions = _this$props5.assetActions,
      asset = _this$props5.asset;
    if (event && event.target.checked) {
      assetActions.selectAll(asset.list.map(selected => selected.id));
    } else {
      assetActions.selectClearAll();
    }
  }
  toggle() {
    const isBulkActionsOpen = this.state.isBulkActionsOpen;
    this.setState({
      isBulkActionsOpen: !isBulkActionsOpen
    });
  }
  render() {
    const _this$props6 = this.props,
      _this$props6$asset = _this$props6.asset,
      indexQuery = _this$props6$asset.indexQuery,
      list = _this$props6$asset.list,
      loading = _this$props6$asset.loading,
      selected = _this$props6$asset.selected,
      canEdit = _this$props6.canEdit;
    const isBulkActionsOpen = this.state.isBulkActionsOpen;
    const rows = list.map((asset, index) => /*#__PURE__*/React.createElement(AssetsRow, {
      data: asset,
      hasActions: canEdit,
      id: asset.id,
      index: index,
      isSelected: _.contains(selected, asset.id),
      key: "ASSET_".concat(asset.id),
      onClick: handleAssetSelect,
      onSelect: this.handleSelect
    }));
    const actionButton = /*#__PURE__*/React.createElement(ButtonDropdown, {
      isOpen: isBulkActionsOpen,
      toggle: this.toggle
    }, /*#__PURE__*/React.createElement(DropdownToggle, {
      id: "assetActions",
      className: "t-a-actions-dropdown",
      size: "sm",
      disabled: selected.length === 0,
      caret: true
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "bolt"
    }), " Actions"), /*#__PURE__*/React.createElement(DropdownMenu, null, /*#__PURE__*/React.createElement(DropdownItem, {
      className: "t-a-duplicate",
      key: "duplicate",
      onClick: () => this.handleAction('duplicate')
    }, "Duplicate")));
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(AssetsFilterPanel, {
      filters: indexQuery.filters,
      onFilter: this.filterChange,
      onFilterClear: this.filterClear,
      onSearch: this.filterSearch,
      onSearchClear: this.filterSearchClear
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(ListPanel, {
      actionButton: canEdit ? actionButton : undefined,
      title: "Assets",
      showNew: canEdit,
      onAdd: this.handleAdd
    }, /*#__PURE__*/React.createElement(AssetsPagingTable, {
      headers: [/*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        onChange: this.handleSelectAll
      }), 'AssetID', 'Alias'],
      loading: loading,
      indexQuery: indexQuery,
      hideSortOptions: true
    }, rows)))));
  }
}
Assets.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  canView: PropTypes.bool.isRequired,
  asset: PropTypes.shape({
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({}),
      paging: PropTypes.shape({
        current: PropTypes.number.isRequired
      }).isRequired,
      sortAttribute: PropTypes.string,
      sortDirection: PropTypes.string
    }),
    initialIndexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})),
    loading: PropTypes.bool,
    selected: PropTypes.arrayOf(PropTypes.string),
    id: PropTypes.string
  }).isRequired,
  assetActions: PropTypes.shape({
    create: PropTypes.func,
    serverFilter: PropTypes.func,
    serverIndex: PropTypes.func,
    select: PropTypes.func,
    selectClear: PropTypes.func,
    selectAll: PropTypes.func,
    selectClearAll: PropTypes.func,
    duplicate: PropTypes.func
  }).isRequired,
  assetStatus: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetStatusActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({}).isRequired,
  login: PropTypes.shape({
    user: PropTypes.shape({
      user_id: PropTypes.string
    })
  }).isRequired
};
export { Assets as TestAssets };
export default entityComposition(Assets, ['asset', 'assetStatus', 'login'], {
  canView: () => getIsPermittedWithAnyOfThesePermissions(['asset_admin']),
  canEdit: () => getIsPermittedWithAnyOfThesePermissions(['asset_admin'])
});